import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import $ from "jquery";
import style from "./style.scss";
import loader from "images/loader.svg";

/**
 * @component Form
 * @props - { object } -  config
 */
class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mailSent: false,
      error: null,
      selectedFile: null,
    };

    this.props.config.fieldsConfig.map((field) => {
      if (field.type === "hidden") {
        this.state[field.fieldName] = field.name;
      }
    });
  }
  /**
   * @function handleFormSubmit
   * @param e { obj } - form event
   * @return void
   */
  handleFormSubmit = (e) => {
    e.preventDefault();

    var data = new FormData();
    var formValidated = false;

    this.props.config.fieldsConfig.map((field) => {
      data.append(field.fieldName, this.state[field.fieldName]);
      if (this.state[field.fieldName]) {
        formValidated = true;
      } else {
        formValidated = false;
        this.setState({ error: true });
        return;
      }
    });

    if (formValidated) {
      $(".loader").addClass("active");
      axios({
        method: "post",
        url: "https://dinamiza.it/mailer/api.php",
        headers: { "content-type": "multipart/form-data" },
        data: data,
      })
        .then((result) => {
          if (result.data.sent) {
            this.setState({
              mailSent: result.data.sent,
            });
            this.setState({ error: false });
            $(".loader").removeClass("active");
            document.getElementById("myForm").reset();
          } else {
            this.setState({ error: true });
          }
        })
        .catch((error) => this.setState({ error: error.message }));
    }
  };
  /**
   * @function handleChange
   * @param e { obj } - change event
   * @param field { string } - namve of the field
   * @return void
   */
  handleChange = (e, field) => {
    let value = e.target.value;
    let updateValue = {};
    updateValue[field] = value;
    this.setState(updateValue);
  };

  onChangeFile = (event) => {
    this.setState({
      file: event.target.files[0],
      loaded: 0,
    });
  };

  componentDidMount() {
    $("form").on("change", ".file-upload-field", function () {
      $(this)
        .parent(".file-upload-wrapper")
        .attr(
          "data-file",
          $(this)
            .val()
            .replace(/.*(\/|\\)/, "")
        );
    });
  }

  render() {
    const {
      klassName,
      successMessage,
      errorMessage,
      fieldsConfig,
    } = this.props.config;
    return (
      <div className={`form-wrapper form-contact-style-dinamiza`}>
        <div>
          <form id={"myForm"} className={klassName} action="#">
            {fieldsConfig &&
              fieldsConfig.map((field) => {
                return (
                  <React.Fragment key={field.id}>
                    {field.type === "textarea" ? (
                      <React.Fragment>
                        <div className={"form-group"}>
                          {field.label ? <label>{field.label}</label> : ""}
                          <textarea
                            className={field.klassName}
                            placeholder={field.placeholder}
                            onChange={(e) =>
                              this.handleChange(e, field.fieldName)
                            }
                            value={field.name}
                            rows={4}
                          />
                        </div>
                      </React.Fragment>
                    ) : field.type === "radio" ? (
                      <React.Fragment>
                        <div className={"form-group"}>
                          <p>
                            {field.label}
                            <br />
                            <a href="https://www.dinamiza.it/informative-privacy">
                              {field.link}
                            </a>
                          </p>
                          <span className={"form-element-radio"}>
                            <input
                              type={field.type}
                              name={field.fieldName}
                              id={field.fieldName + field.name1}
                              value={field.name1}
                              onChange={(e) =>
                                this.handleChange(e, field.fieldName)
                              }
                            />
                            <label htmlFor={field.fieldName + field.name1}>
                              {field.name1}
                            </label>
                          </span>

                          {field.name2 ? (
                            <span className={"form-element-radio"}>
                              <input
                                type={field.type}
                                name={field.fieldName}
                                id={field.fieldName + field.name2}
                                value={field.name2}
                                onChange={(e) =>
                                  this.handleChange(e, field.fieldName)
                                }
                              />
                              <label htmlFor={field.fieldName + field.name2}>
                                {field.name2}
                              </label>
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </React.Fragment>
                    ) : field.type === "file" ? (
                      <React.Fragment>
                        <div className={"form-group"}>
                          <label
                            className={"file-upload-wrapper"}
                            data-text={field.label}
                            data-file={""}
                          >
                            <input
                              type={field.type}
                              className={`${field.klassName} file-upload-field`}
                              name={field.fieldName}
                              placeholder={field.placeholder}
                              value={field.name}
                              onChange={this.onChangeFile}
                            />
                          </label>
                        </div>
                      </React.Fragment>
                    ) : (
                      <div className={"form-group"}>
                        <React.Fragment>
                          {field.label ? <label>{field.label}</label> : ""}
                          <input
                            type={field.type}
                            className={field.klassName}
                            placeholder={field.placeholder}
                            name={field.fieldName}
                            value={field.name}
                            onChange={(e) =>
                              this.handleChange(e, field.fieldName)
                            }
                          />
                        </React.Fragment>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            <input
              type="submit"
              onClick={(e) => this.handleFormSubmit(e)}
              value="Invia il modulo"
            />
            <div>
              {this.state.mailSent && (
                <div className="success" data-success>
                  {successMessage}
                </div>
              )}
              {this.state.error && (
                <div className="error" data-error>
                  {errorMessage}
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default Form;
//propTypes for the component
Form.propTypes = {
  config: PropTypes.object.isRequired,
};
